module.exports = __webpack_public_path__ + "img/404.743b1053.png";